import { Capacitor } from "@capacitor/core";
import { AppUpdate } from "@capawesome/capacitor-app-update";

export function isNativePlatform() {
	if (["ios", "android"].includes(Capacitor.getPlatform())) return true;
	return !!window.Capacitor?.Plugins?.App;
}

export function isIos() {
	if (Capacitor.getPlatform() === "ios") return true;
	return isNativePlatform() && /iPhone|iPad|iPod/.test(navigator.userAgent);
}

export async function openAppStore() {
	await AppUpdate.openAppStore();
}

export const getAppStoreName = () => {
	if (isIos()) {
		return "App store";
	}

	return "Google Play";
};
